export default __webpack_public_path__ + "static/media/avatar_group.9ce09b6a.jpg";